import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Linkedin, Facebook, Youtube, Instagram, ArrowRight } from "lucide-react";
import { ApexLogo } from "@/components/ApexLogo";
import { NAV_LINKS } from "@/lib/constants";

const LEGAL = [
  { label: "Privacy Policy", to: "/legal/privacy" },
  { label: "Cookies", to: "/legal/cookies" },
  { label: "Terms & Conditions", to: "/legal/terms" },
  { label: "Accessibility", to: "/legal/accessibility" },
  { label: "Complaints", to: "/legal/complaints" },
  { label: "Regulatory Information", to: "/legal/regulatory" },
];

export default function Footer({ settings = {} }) {
  const social = settings.social || {};
  return (
    <footer data-testid="site-footer" className="bg-navy text-slate-300">
      <div className="container-x grid grid-cols-1 gap-10 py-14 md:grid-cols-4">
        <div>
          <ApexLogo light />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-300">
            {settings.footer_text || "From Advice to Settlement, We Walk the Path with You."}
          </p>
          <div className="mt-5 flex gap-3">
            {social.linkedin && <a href={social.linkedin} aria-label="LinkedIn" className="rounded-full bg-navy-light p-2 hover:bg-gold hover:text-navy transition-colors"><Linkedin size={16} /></a>}
            {social.facebook && <a href={social.facebook} aria-label="Facebook" className="rounded-full bg-navy-light p-2 hover:bg-gold hover:text-navy transition-colors"><Facebook size={16} /></a>}
            {social.youtube && <a href={social.youtube} aria-label="YouTube" className="rounded-full bg-navy-light p-2 hover:bg-gold hover:text-navy transition-colors"><Youtube size={16} /></a>}
            {social.instagram && <a href={social.instagram} aria-label="Instagram" className="rounded-full bg-navy-light p-2 hover:bg-gold hover:text-navy transition-colors"><Instagram size={16} /></a>}
          </div>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-slate-300 hover:text-gold transition-colors">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Contact Us</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            {settings.phone && <li className="flex items-center gap-2"><Phone size={15} className="text-gold" /><a href={`tel:${settings.phone}`} className="hover:text-gold">{settings.phone}</a></li>}
            {settings.email && <li className="flex items-center gap-2"><Mail size={15} className="text-gold" /><a href={`mailto:${settings.email}`} className="hover:text-gold">{settings.email}</a></li>}
            {settings.office && <li className="flex items-center gap-2"><MapPin size={15} className="text-gold" />{settings.office}</li>}
          </ul>
          <Link to="/book-consultation" className="btn-gold mt-5 text-sm">Book a Consultation <ArrowRight size={15} /></Link>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold uppercase tracking-wider text-white">Legal & Regulatory</h4>
          <ul className="space-y-2 text-sm">
            {LEGAL.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-slate-300 hover:text-gold transition-colors">{l.label}</Link></li>
            ))}
          </ul>
          <p className="mt-4 text-xs leading-relaxed text-slate-300">
            IAA registration details to be displayed once formally confirmed.
          </p>
        </div>
      </div>
      <div className="border-t border-navy-light">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-slate-300 sm:flex-row">
          <p>© {new Date().getFullYear()} ApexPath Ltd. All rights reserved.</p>
          <p>Immigration advice provided within ApexPath's authorised scope.</p>
        </div>
      </div>
    </footer>
  );
}
